<template>
  <div>
    <v-row style="margin-left:20px;margin-right:20px;">
      <v-col md="1"></v-col>
      <v-col md="10" style="margin-top:10px;margin-bottom:10px;">
        <div style="background-color:white">
          <v-card>
            <v-card-title class="prfont">My Order List</v-card-title>
          </v-card>
          <hr />
          <br />
          <v-card>
            <div v-for="i in productdata">
              <div v-for="j in i.receipt">
                <v-row>
                  <v-col md="4">
                    <div v-for="l in i.tracking">
                      <span><b>
                        &nbsp;&nbsp;Order placed on :
                        <br />
                        &nbsp;&nbsp;{{l.created_date.slice(0,10)}}</b>
                      </span>
                    </div>
                  </v-col>
                  <v-col md="4" align="center">
                    <span><b>
                      Ship To :</b>
                      <br />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span
                            style="color:blue;"
                            v-on="on"
                          >{{i.deliveryaddress.firstname}} {{i.deliveryaddress.lastname}}</span>
                        </template>
                        <span>
                          {{i.deliveryaddress.streetAddress}}
                          <br />
                          {{i.deliveryaddress.locality}}
                          <br />
                          <!-- {{i.deliveryaddress.city.name}},
                          {{i.deliveryaddress.district.name}} -->
                          <v-spacer />
                          Pincode::{{i.deliveryaddress.pincode}}
                          <br />
                          {{i.deliveryaddress.country}}
                          <br />
                          Mobile::{{i.mobile}}
                        </span>
                      </v-tooltip>
                    </span>
                  </v-col>

                  <v-col md="4">
                    <span style="float:right;padding-right:10px;font-size:20px;">
                      <a
                        target="_blank"
                        :href="'https://api.inguzsales.in/Purchase/printreceipt?id='+i._id+'&index='+j.index"
                        class="downlink"
                      >Invoice</a>
                    </span>
                  </v-col>
                   <!-- <v-col md="4"  style="float:right;color:#f6782a;">
                            <div v-for="l in i.tracking">
                            <strong class="prfont">
                              Delivered on :
                              {{l.coureier.expecteddeliverydate}}
                            </strong>
                            </div>
                          </v-col> -->
                </v-row>
                <router-link  :to="'/Product/' +productname">
                <v-card>
                 <v-row>
                    <div v-for="k in j.product">
                      <v-row>
                      <v-col md="2">
                        <v-col md="12">
                          <v-card class="jj">
                            <v-img
                              :src="'https://api.inguzsales.in/u/'+k.photos[0]"
                              style="width:auto;height:100%;object-fit:cover;"
                            />
                          </v-card>
                        </v-col>
                      </v-col>
                       <v-col md="9" style="padding-top:20px;">
                         <v-col md="12">
                        <v-row>
                          <v-col md="8">
                            <h3 style="color:black;">
                              <strong class="prfont">{{k.productname}}</strong>
                            </h3>
                          </v-col>
                          <v-col md="4">
                            <v-row justify="center">
                           <h2 style="color:black"><strong class="prfont"> ₹ {{k.price}}</strong></h2>
                            </v-row>
                          </v-col>
                          <br />
                           <v-row md="12" class="prfont hr" justify="space-around">
                           {{k.description.slice(0,200)}}......
                           
                          </v-row>
                          <br />
                        </v-row>
                         </v-col>
                      </v-col>
                    </v-row>
                      </div>
                   </v-row>
                </v-card>
                
                </router-link>
              </div>
            </div>
          </v-card>
           <hr/>
           <br/>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";

export default {
  props: ["id"],
  components: {
    StarRating
  },
  data() {
    return {
      len: "",
      shipp: "",
      productdata: [],
      total: "",
      subtotal: "",
      productdata: '',
      productname:'',

      tottax: "",
      states: [],
      statesId: [],
      state: null,
      stateId: null,
      districts: [],
      districtsId: [],
      district: null,
      districtId: null,
      cities: [],
      citiesId: [],
      city: null,
      cityId: null
    };
  },
  beforeMount() {
    this.stateList();
  },
  watch: {
    state: function() {
      this.districtList();
    },
    district: function() {
      this.cityList();
    }
  },
  mounted: function() {
    this.getProduct();
    this.getProduct1();
  },
  methods: {
    getProduct() {
      axios({
        method: "GET",
        url: "/purchase/myorders",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
        // params:{
        //    purchaseid: this._id
        // },
      }).then(response => {
        this.productdata = response.data.data;
          var tempflag = [];
        for (var i = 0; i < this.productdata.length; i++) {
          for (var j=0; j < this.productdata[i].product.length;j++){
          var tyimg = productdata[i].product[j].productname;
          tempflag.push(tyimg);
          }
          console.log(tempflag)
        }
        this.productname = tempflag;  





     // this.total =  Math.round(Response.data.total);
        // this.subtotal = Math.round( Response.data.subtotal);
        // this.tottax = Math.round(Response.data.totaltax);
        // this.shipp= Math.round(Response.data.shippingcharge);
        // console.log(Response);
      });
    },
    getProduct1() {
      axios({
        method: "GET",
        url: "/purchase/printreceipt",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
        // params:{
        //    purchaseid: this._id
        // },
      }).then(response => {
        // this.productdata = response.data.data;
        // console.log(this.productdata);
        // this.total =  Math.round(Response.data.total);
        // this.subtotal = Math.round( Response.data.subtotal);
        // this.tottax = Math.round(Response.data.totaltax);
        // this.shipp= Math.round(Response.data.shippingcharge);
        // console.log(Response);
      });
    },
    stateList() {
      // this.dialog = false;

      axios({
        method: "GET",
        url: "/loc/StateList/"
      })
        .then(response => {
          this.states = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.states.length; i++) {
            var ty = this.states[i].name;
            var tyid = this.states[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.states = temp;
          this.statesId = tempid;

          console.log(err);
        })
        .catch(err => {
          this.msg = "Something Went Wrong";
          // alert(err);
          // console.log(err);
        });
    },
    districtList() {
      this.visible = true;
      for (var j = 0; j < this.states.length; j++) {
        if (this.state == this.states[j]) {
          this.stateId = this.statesId[j];
        }
      }
      axios({
        method: "GET",
        url: "/loc/DistrictList/?stateid=" + this.stateId
      })
        .then(response => {
          // console.log("VehicleModel", response);
          this.districts = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.districts.length; i++) {
            var ty = this.districts[i].name;
            var tyid = this.districts[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.districts = temp;
          this.districtsId = tempid;
          this.visible = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    cityList() {
      this.visible = true;
      for (var j = 0; j < this.districts.length; j++) {
        if (this.district == this.districts[j]) {
          this.districtId = this.districtsId[j];
        }
      }
      axios({
        method: "GET",
        url: "/loc/CityList/?districtid=" + this.districtId
      })
        .then(response => {
          // console.log("VehicleModel", response);
          this.cities = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.cities.length; i++) {
            var ty = this.cities[i].name;
            var tyid = this.cities[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.cities = temp;
          console.log(cities)
          this.citiesId = tempid;
          this.visible = false;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.prfont {
  font-family: "Montserrat";
}
@media (min-width: 360px) and (max-width: 640px) {
  .hr{
    width:100px;
  }
}
.by {
  width: 28px;
  height: 28px;
  background: linear-gradient(#fff, #f9f9f9);
  display: inline-block;
  border: 1px solid #c2c2c2;
  cursor: pointer;
  font-size: 16px;
  border-radius: 50%;
  padding-top: 1px;
  line-height: 1;
}
.bu {
  width: 28px;
  height: 28px;
  background: linear-gradient(#fff, #f9f9f9);
  display: inline-block;
  border: 1px solid #c2c2c2;
  cursor: pointer;
  font-size: 16px;

  padding-top: 1px;
  line-height: 1;
}
.jj {
  height: 146px;
  width: 143px;
}
</style>